<template>
  <div class="d-flex flex-row align-start">
    <v-icon size="30" :icon="mdiHistory" />
    <div class="d-flex flex-column ml-2">
      <sf-text v-html="safeMessage" />
      <sf-secondary-text>{{ formatRelativeDate(entry.timestamp) }}</sf-secondary-text>
    </div>
  </div>
</template>

<script lang="ts">
import SfSecondaryText from '@/components/text/SfSecondaryText.vue'
import SfText from '@/components/text/SfText.vue'
import { QuoteActivity } from '@/types/index'
import { formatRelativeDate } from '@/utils/timeFormatHelpers'
import { mdiHistory } from '@mdi/js'
import DOMPurify from 'dompurify'
import { PropType, computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'QuoteActivityEntry',
  components: { SfText, SfSecondaryText },
  props: {
    entry: {
      type: Object as PropType<QuoteActivity>,
      required: true
    }
  },
  setup(props) {
    const safeMessage = computed(() => {
      const fullName = props.entry.user.fullName
      const message = props.entry.message

      const sanitizedMessage = DOMPurify.sanitize(message)

      return `${fullName}: ${sanitizedMessage}`
    })
    return {
      formatRelativeDate,
      mdiHistory,
      safeMessage
    }
  }
})
</script>
